import store from "../store";
import usuario from "@/services/usuario";

export default async (to, from, next) => {
  if (to.fullPath === "/logout") {
    store.dispatch("logout");
    next("/");
    return;
  }
  
  store.dispatch('desconto', {val: false});
  if (!to.fullPath.includes("/admin")) {
    store.dispatch('desconto', {val: true});
  }
  await store.dispatch("init");
  if (to.fullPath.includes("admin") && !store.getters.user) {
    // if (store.getters.user) {
    //   next("/");
    //   return;
    // } else {
    next("/signin");
    return;
    //}
  }
  if (store.getters.user) {
    await usuario.getUsuario(store.getters.user._id).then(res => {
      if (!res) {
        store.dispatch("logout");
      }
      if (res.grand == "Cliente" && to.fullPath.includes("/admin")) {
        
        next("/");
        return;
      } else if (store.getters.user) {
        next();
        return;
      } else {
        next("/home-admin");
        return;
      }
    });
  } else {
    
    next();
    return;
  }
};



// WEBPACK FOOTER //
// ./src/router/auth-guard.js